const InstagramPreview = ({ username }) => {
  return (
    <div className="instagram-preview">
      <iframe
        src={`https://www.instagram.com/${username}/embed`}
        width="320"
        height="400"
        frameBorder="0"
        scrolling="no"
        title="Instagram Preview"
      ></iframe>
    </div>
  );
};

export default InstagramPreview;
